import styled from 'styled-components'

interface IItemPriceStyledProps {}

export const ItemPriceStyled = styled.div<IItemPriceStyledProps>`
  font-size: 1em;
  text-align: right;
`
